<template>
  <page-header-wrapper>
    <div class="allowance-page erp-list-page baidao-list-page">
      <div class="erp-search-card">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24"><a-form-item label="日期范围"><a-range-picker v-model="dateRange" style="width:100%" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="折让单号"><a-input v-model="query.allowanceNo" allow-clear placeholder="请输入折让单号" @pressEnter="search" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="客商"><a-input v-model="query.customerKeyword" allow-clear placeholder="客商编号或名称" @pressEnter="search" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="出库单号"><a-input v-model="query.outboundNo" allow-clear placeholder="关联销售出库单号" @pressEnter="search" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="审核状态"><a-select v-model="query.auditStatus" allow-clear placeholder="全部"><a-select-option value="unaudited">未审核</a-select-option><a-select-option value="audited">已审核</a-select-option></a-select></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="业务员"><a-select v-model="query.salesUserId" allow-clear show-search option-filter-prop="children" placeholder="全部业务员"><a-select-option v-for="user in userOptions" :key="user.id" :value="user.id">{{ user.nickName || user.userName }}</a-select-option></a-select></a-form-item></a-col>
            <a-col :md="24" :sm="24" class="erp-search-actions"><a-button type="primary" icon="search" @click="search">查询</a-button><a-button icon="redo" @click="reset">重置</a-button></a-col>
          </a-row>
        </a-form>
      </div>
      <div class="erp-table-card">
        <div class="erp-table-toolbar">
          <div><h3>销售折让单</h3><p>关联已审核销售出库单，登记客户价款折让并留存审批依据。</p></div>
          <div class="erp-toolbar-actions"><a-button type="primary" icon="plus" @click="openCreate">新建折让单</a-button></div>
        </div>
        <a-table
          :row-key="rowKey"
          :columns="columns"
          :data-source="rows"
          :loading="loading"
          :pagination="pagination"
          bordered
          size="middle"
          :scroll="{ x: 1600 }"
          @change="onPageChange">
          <template slot="number" slot-scope="value, record"><a @click="openDetail(record)">{{ value }}</a></template>
          <template slot="status" slot-scope="value"><a-tag class="erp-status-tag" :color="value === 'audited' ? 'green' : 'orange'">{{ statusText(value) }}</a-tag></template>
          <template slot="money" slot-scope="value"><span class="erp-money">¥{{ formatMoney(value) }}</span></template>
          <template slot="actions" slot-scope="value, record">
            <a @click="openDetail(record)">查看</a>
            <template v-if="record.auditStatus !== 'audited'"> <a-divider type="vertical" /><a @click="openDetail(record, true)">编辑</a><a-divider type="vertical" /><a @click="confirmAction('审核', record, auditSalesAllowance)">审核</a><a-divider type="vertical" /><a class="erp-danger-link" @click="confirmAction('删除', record, deleteSalesAllowance)">删除</a></template>
            <template v-if="record.auditStatus === 'audited'"> <a-divider type="vertical" /><a @click="confirmAction('反审核', record, reverseAuditSalesAllowance)">反审核</a></template>
          </template>
        </a-table>
      </div>
      <a-drawer
        :visible="drawerVisible"
        :width="drawerWidth"
        :closable="false"
        :body-style="{ padding: 0 }"
        :mask-closable="false"
        class="erp-doc-drawer baidao-drawer-sample"
        @close="closeDrawer">
        <div class="erp-drawer-shell">
          <header class="erp-drawer-header">
            <div><button class="erp-back-button" type="button" @click="closeDrawer"><a-icon type="arrow-left" /></button><span class="erp-drawer-kicker">{{ readOnly ? '查看单据' : (form.id ? '编辑单据' : '新建单据') }}</span><h3>{{ form.allowanceNo || '新建销售折让单' }}</h3></div>
            <div><a-button @click="closeDrawer">取消</a-button><a-button v-if="editable" type="primary" :loading="saving" @click="save">保存</a-button></div>
          </header>
          <div class="erp-drawer-content">
            <div class="erp-status-strip"><a-tag class="erp-status-tag" :color="form.auditStatus === 'audited' ? 'green' : 'orange'">{{ statusText(form.auditStatus) }}</a-tag><span v-if="form.auditStatus === 'audited'">已审核；折让金额可作为后续客户对账调整依据。</span><span v-else>保存后仍为未审核；审核前会校验累计折让不超过出库行价税合计。</span></div>
            <section class="erp-form-card">
              <div class="erp-section-title"><span class="erp-section-index">01</span><div><h4>基础信息</h4><p>选择已审核销售出库单后自动带出客户信息</p></div></div>
              <div class="erp-base-grid">
                <label><span><b class="erp-required">*</b> 单据日期</span><a-date-picker v-model="form.allowanceDate" value-format="YYYY-MM-DD" style="width:100%" :disabled="!editable" /></label>
                <label><span><b class="erp-required">*</b> 关联出库单</span><a-select
                  v-model="form.outboundId"
                  :disabled="!editable"
                  show-search
                  allow-clear
                  :filter-option="false"
                  placeholder="搜索出库单号或客户"
                  not-found-content="暂无已审核过账的销售出库单"
                  @search="searchOutboundSources"
                  @dropdownVisibleChange="onOutboundDropdown"
                  @change="outboundChanged"><a-select-option v-for="item in outboundOptions" :key="String(item.outboundId)" :value="normalizeId(item.outboundId)">{{ item.outboundNo }} · {{ item.customerName }}</a-select-option></a-select></label>
                <label><span>客户</span><a-input :value="form.customerName || '—'" disabled /></label>
                <label><span>出库价税合计</span><a-input :value="form.outboundTotalAmount != null ? '¥' + formatMoney(form.outboundTotalAmount) : '—'" disabled /></label>
                <label class="wide"><span>备注</span><a-input v-model="form.remark" :disabled="!editable" placeholder="折让原因或审批依据（选填）" /></label>
              </div>
            </section>
            <section class="erp-form-card">
              <div class="erp-section-heading-row">
                <div class="erp-section-title"><span class="erp-section-index">02</span><div><h4>商品明细</h4><p>折让金额不得超过对应出库总金额</p></div></div>
                <div v-if="editable" class="allowance-line-actions">
                  <a-button :disabled="!form.outboundId" @click="openProductPicker">选择商品</a-button>
                </div>
              </div>
              <div v-if="!form.items.length" class="empty-lines"><a-empty description="请先选择关联销售出库单，再点击「选择商品」" /></div>
              <p v-else-if="!hasPositiveOutboundLine" class="allowance-zero-cap-hint">出库总金额为 0（常见于订单单价未填），无法登记折让，请先在销售订单/出库单补全单价。</p>
              <div v-if="form.items.length" class="erp-line-table-wrap allowance-line-table-wrap">
                <table class="erp-line-table allowance-line-table">
                  <thead>
                    <tr>
                      <th>序号</th>
                      <th>商品编码</th>
                      <th>商品名称</th>
                      <th>规格名称</th>
                      <th>单位</th>
                      <th>出库数量</th>
                      <th>出库总金额(元)</th>
                      <th>折让金额(元)</th>
                      <th v-if="editable">操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in form.items" :key="item.outboundItemId + '-' + index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.skuCode }}</td>
                      <td>{{ item.skuName }}</td>
                      <td>{{ item.skuSpecName || '—' }}</td>
                      <td>{{ item.unitName || '—' }}</td>
                      <td>{{ formatQty(item.qtyBusiness) }}</td>
                      <td class="erp-money">¥{{ formatMoney(item.outboundLineAmount) }}</td>
                      <td>
                        <a-input-number
                          v-if="editable"
                          v-model="item.allowanceAmount"
                          :min="0"
                          :max="lineAllowanceMax(item)"
                          :precision="2"
                          style="width:120px" />
                        <span v-else class="erp-money">¥{{ formatMoney(item.allowanceAmount) }}</span>
                      </td>
                      <td v-if="editable"><a class="erp-danger-link" @click="form.items.splice(index, 1)">删除</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="outbound-summary allowance-totals">
                <span>出库总金额(元)：<b>¥{{ totalOutboundAmount }}</b></span>
                <span>折让总金额(元)：<strong>¥{{ totalAllowance }}</strong></span>
              </div>
            </section>
          </div>
          <footer class="erp-drawer-footer"><div><a-icon type="info-circle" /> 审核后不修改出库库存，仅登记价款折让。</div><div><a-button @click="closeDrawer">返回列表</a-button><a-button v-if="editable" type="primary" :loading="saving" @click="save">保存</a-button></div></footer>
        </div>
      </a-drawer>
      <a-modal
        v-model="pickerVisible"
        title="选择折让商品"
        width="920px"
        :mask-closable="false"
        ok-text="确定"
        cancel-text="取消"
        @ok="confirmProductPicker">
        <p class="allowance-picker-tip">仅可选择当前关联出库单「{{ form.outboundNo || '—' }}」中的出库商品。</p>
        <a-table
          :row-key="row => String(row.outboundItemId)"
          :columns="pickerColumns"
          :data-source="outboundLinePool"
          :pagination="false"
          size="small"
          bordered
          :scroll="{ y: 320 }"
          :row-selection="pickerRowSelection">
          <template slot="pickerSpec" slot-scope="text">{{ text || '—' }}</template>
          <template slot="pickerUnit" slot-scope="text">{{ text || '—' }}</template>
          <template slot="pickerQty" slot-scope="text">{{ formatQty(text) }}</template>
          <template slot="pickerAmount" slot-scope="text"><span class="erp-money">¥{{ formatMoney(text) }}</span></template>
        </a-table>
      </a-modal>
    </div>
  </page-header-wrapper>
</template>

<script>
import moment from 'moment'
import { pageUser } from '@/api/system/user'
import {
  pageSalesAllowance,
  getSalesAllowance,
  listAllowanceOutboundSources,
  listAllowanceOutboundLines,
  createSalesAllowance,
  updateSalesAllowance,
  auditSalesAllowance,
  reverseAuditSalesAllowance,
  deleteSalesAllowance
} from '@/api/erp/salesAllowance'

const blankForm = () => ({
  id: null,
  allowanceNo: '',
  allowanceDate: moment().format('YYYY-MM-DD'),
  outboundId: undefined,
  outboundNo: '',
  customerName: '',
  outboundTotalAmount: null,
  auditStatus: 'unaudited',
  remark: '',
  items: []
})

export default {
  name: 'ErpSalesAllowanceV2',
  data () {
    return {
      loading: false,
      saving: false,
      drawerVisible: false,
      readOnly: false,
      viewportWidth: window.innerWidth,
      form: blankForm(),
      userOptions: [],
      outboundOptions: [],
      outboundLinePool: [],
      pickerVisible: false,
      pickerSelectedKeys: [],
      pickerColumns: [
        { title: '商品编码', dataIndex: 'skuCode', width: 120 },
        { title: '商品名称', dataIndex: 'skuName', width: 160 },
        { title: '规格名称', dataIndex: 'skuSpecName', width: 120, scopedSlots: { customRender: 'pickerSpec' } },
        { title: '单位', dataIndex: 'unitName', width: 80, scopedSlots: { customRender: 'pickerUnit' } },
        { title: '出库数量', dataIndex: 'qtyBusiness', width: 100, scopedSlots: { customRender: 'pickerQty' } },
        { title: '出库总金额(元)', dataIndex: 'outboundLineAmount', width: 130, scopedSlots: { customRender: 'pickerAmount' } }
      ],
      rows: [],
      dateRange: [],
      query: { allowanceNo: '', customerKeyword: '', outboundNo: '', auditStatus: undefined, salesUserId: undefined },
      pagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true },
      columns: [
        { title: '折让单号', dataIndex: 'allowanceNo', width: 180, scopedSlots: { customRender: 'number' } },
        { title: '单据日期', dataIndex: 'allowanceDate', width: 120 },
        { title: '审核状态', dataIndex: 'auditStatus', width: 100, scopedSlots: { customRender: 'status' } },
        { title: '客户编码', dataIndex: 'customerCode', width: 120 },
        { title: '客户名称', dataIndex: 'customerName', width: 160 },
        { title: '关联出库单', dataIndex: 'outboundNo', width: 180 },
        { title: '折让金额', dataIndex: 'totalAllowanceAmount', width: 120, scopedSlots: { customRender: 'money' } },
        { title: '业务员', dataIndex: 'salesUserName', width: 120 },
        { title: '备注', dataIndex: 'remark', ellipsis: true },
        { title: '操作', key: 'actions', fixed: 'right', width: 220, scopedSlots: { customRender: 'actions' } }
      ]
    }
  },
  computed: {
    drawerWidth () { return this.viewportWidth > 1400 ? 980 : '92vw' },
    editable () { return !this.readOnly && this.form.auditStatus !== 'audited' },
    totalAllowance () {
      return this.form.items.reduce((sum, row) => sum + Number(row.allowanceAmount || 0), 0).toFixed(2)
    },
    totalOutboundAmount () {
      return this.form.items.reduce((sum, row) => sum + Number(row.outboundLineAmount || 0), 0).toFixed(2)
    },
    hasPositiveOutboundLine () {
      return this.form.items.some(row => Number(row.outboundLineAmount || 0) > 0)
    },
    pickerRowSelection () {
      const self = this
      return {
        selectedRowKeys: self.pickerSelectedKeys,
        onChange (keys) { self.pickerSelectedKeys = keys.map(String) }
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.onResize)
    pageUser({ pageNum: 1, pageSize: 200 }).then(res => { this.userOptions = (res.data && res.data.records) || [] })
    this.load()
    this.searchOutboundSources('')
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    rowKey (record) { return record.id },
    onResize () { this.viewportWidth = window.innerWidth },
    formatMoney (value) { return Number(value || 0).toFixed(2) },
    formatQty (value) {
      const num = Number(value || 0)
      return Number.isInteger(num) ? String(num) : num.toFixed(6).replace(/\.?0+$/, '')
    },
    lineAllowanceMax (item) {
      const cap = Number(item.outboundLineAmount || 0)
      const available = Number(item.allowanceAvailableAmount != null ? item.allowanceAvailableAmount : cap)
      return Math.max(0, Math.min(cap, available))
    },
    statusText (value) { return value === 'audited' ? '已审核' : '未审核' },
    buildQuery () {
      const params = Object.assign({}, this.query, {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      })
      if (this.dateRange && this.dateRange.length === 2) {
        params.dateStart = this.dateRange[0].format('YYYY-MM-DD')
        params.dateEnd = this.dateRange[1].format('YYYY-MM-DD')
      }
      return params
    },
    load () {
      this.loading = true
      pageSalesAllowance(this.buildQuery()).then(res => {
        const page = res.data || {}
        this.rows = page.records || []
        this.pagination.total = Number(page.total || 0)
      }).finally(() => { this.loading = false })
    },
    search () { this.pagination.current = 1; this.load() },
    reset () {
      this.query = { allowanceNo: '', customerKeyword: '', outboundNo: '', auditStatus: undefined, salesUserId: undefined }
      this.dateRange = []
      this.search()
    },
    onPageChange (pager) {
      this.pagination.current = pager.current
      this.pagination.pageSize = pager.pageSize
      this.load()
    },
    openCreate () {
      this.form = blankForm()
      this.outboundLinePool = []
      this.readOnly = false
      this.drawerVisible = true
      this.searchOutboundSources('')
    },
    normalizeId (value) {
      if (value === null || value === undefined || value === '') return value
      return String(value)
    },
    onOutboundDropdown (open) {
      if (open) this.searchOutboundSources('')
    },
    openDetail (record, edit) {
      getSalesAllowance(record.id).then(res => {
        const data = res.data || {}
        this.form = Object.assign(blankForm(), data, { items: (data.items || []).map(row => Object.assign({}, row)) })
        this.readOnly = !edit
        this.drawerVisible = true
        this.ensureOutboundOption(data)
        if (data.outboundId) {
          this.loadOutboundLinePool()
        }
      })
    },
    closeDrawer () { this.drawerVisible = false },
    ensureOutboundOption (data) {
      if (!data.outboundId) return
      const exists = this.outboundOptions.some(row => row.outboundId === data.outboundId)
      if (!exists) {
        this.outboundOptions.unshift({
          outboundId: data.outboundId,
          outboundNo: data.outboundNo,
          customerName: data.customerName,
          totalTaxAmount: data.outboundTotalAmount
        })
      }
    },
    searchOutboundSources (keyword) {
      listAllowanceOutboundSources({ keyword: keyword || '' }).then(res => {
        this.outboundOptions = res.data || []
        if (!this.outboundOptions.length && !(keyword || '').trim()) {
          this.$message.info('当前没有可选出库单：需为已审核且库存已过账的正常销售出库单')
        }
      }).catch(() => {
        this.outboundOptions = []
      })
    },
    outboundChanged (outboundId) {
      const selected = this.outboundOptions.find(row => String(row.outboundId) === String(outboundId))
      if (selected) {
        this.form.outboundNo = selected.outboundNo
        this.form.customerName = selected.customerName
        this.form.outboundTotalAmount = selected.totalTaxAmount
      }
      this.form.items = []
      this.loadOutboundLinePool()
    },
    loadOutboundLinePool () {
      if (!this.form.outboundId) {
        this.outboundLinePool = []
        return Promise.resolve([])
      }
      return listAllowanceOutboundLines({
        outboundId: String(this.form.outboundId),
        excludeAllowanceId: this.form.id ? String(this.form.id) : undefined
      }).then(res => {
        this.outboundLinePool = (res.data || []).map(row => Object.assign({}, row, {
          outboundItemId: String(row.outboundItemId),
          allowanceAmount: 0
        }))
        if (!this.outboundLinePool.length) {
          this.$message.warning('该出库单没有商品明细')
        }
        return this.outboundLinePool
      }).catch(err => {
        this.outboundLinePool = []
        this.$message.error((err && err.message) || '加载出库商品失败')
        return []
      })
    },
    openProductPicker () {
      if (!this.form.outboundId) {
        this.$message.warning('请先选择关联销售出库单')
        return
      }
      const open = () => {
        this.pickerSelectedKeys = this.form.items.map(row => String(row.outboundItemId))
        this.pickerVisible = true
      }
      if (this.outboundLinePool.length) {
        open()
        return
      }
      this.loadOutboundLinePool().then(open)
    },
    confirmProductPicker () {
      if (!this.pickerSelectedKeys.length) {
        this.$message.warning('请至少选择一个商品')
        return false
      }
      const oldMap = {}
      this.form.items.forEach(row => { oldMap[String(row.outboundItemId)] = row.allowanceAmount })
      const poolMap = {}
      this.outboundLinePool.forEach(row => { poolMap[String(row.outboundItemId)] = row })
      this.form.items = this.pickerSelectedKeys.map(key => {
        const source = poolMap[key]
        return Object.assign({}, source, {
          allowanceAmount: oldMap[key] != null ? oldMap[key] : 0
        })
      })
      this.pickerVisible = false
    },
    save () {
      const items = this.form.items
        .filter(row => Number(row.allowanceAmount || 0) > 0)
        .map(row => ({ outboundItemId: row.outboundItemId, allowanceAmount: row.allowanceAmount }))
      if (!this.form.allowanceDate) {
        this.$message.warning('请选择单据日期')
        return
      }
      if (!this.form.outboundId) {
        this.$message.warning('请选择关联销售出库单')
        return
      }
      if (!items.length) {
        this.$message.warning('请至少填写一行折让金额')
        return
      }
      const payload = {
        id: this.form.id,
        allowanceDate: this.form.allowanceDate,
        outboundId: this.form.outboundId,
        remark: this.form.remark,
        items
      }
      this.saving = true
      const request = this.form.id ? updateSalesAllowance(payload) : createSalesAllowance(payload)
      request.then(res => {
        this.$message.success(this.form.id ? '销售折让单已保存' : '销售折让单已创建')
        this.form = Object.assign(blankForm(), res.data || {}, { items: ((res.data && res.data.items) || []).map(row => Object.assign({}, row)) })
        this.readOnly = false
        this.load()
      }).finally(() => { this.saving = false })
    },
    confirmAction (label, record, action) {
      const self = this
      this.$confirm({
        title: label + '销售折让单',
        content: '确认对 ' + record.allowanceNo + ' 执行' + label + '？',
        onOk () {
          return action(record.id).then(() => {
            self.$message.success(label + '成功')
            self.load()
            if (self.drawerVisible && self.form.id === record.id) {
              getSalesAllowance(record.id).then(res => {
                const data = res.data || {}
                self.form = Object.assign(blankForm(), data, { items: (data.items || []).map(row => Object.assign({}, row)) })
                self.readOnly = true
              })
            }
          })
        }
      })
    },
    auditSalesAllowance,
    reverseAuditSalesAllowance,
    deleteSalesAllowance
  }
}
</script>

<style scoped>
.allowance-page .allowance-zero-cap-hint {
  margin: 0 0 12px;
  color: #d48806;
  font-size: 13px;
}
.allowance-page .allowance-line-actions {
  display: flex;
  gap: 8px;
}
.allowance-page .allowance-line-table-wrap {
  overflow-x: auto;
}
.allowance-page .allowance-totals {
  display: flex;
  justify-content: flex-end;
  gap: 24px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}
.allowance-page .allowance-picker-tip {
  margin-bottom: 12px;
  color: rgba(0, 0, 0, 0.65);
}
.allowance-page .outbound-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}
</style>
